import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { shape, string } = proptypes;

export const Summary = ({ reviews }) => {
  return (
    <div>
      <Typography variant="body-base" height="tight">{reviews?.summary}</Typography>
    </div>
  );
};

Summary.propTypes = {
  reviews: shape({
    summary: string,
    positiveSummary: string,
    negativeSummary: string
  }).isRequired
};
